<template>
  <div class='edit-sp-employee-container-header'>
    <div class='edit-sp-employee-profile-header-container'>
      <div class="edit-sp-employee-profile-title d-inline-block">{{ $t('edit.sp.employee.profile.title') }}</div>
      <EditSPEmployeeProfileControlButtons
        @onOpenPreviewClicked='onOpenPreviewClicked'
        @onDeleteClicked='onDeleteClicked'
        @onEscapeClicked='onEscapeClicked'
        @onResetActiveClicked='onResetActiveClicked'
        class='edit-sp-employee-profile-header-container-control-buttons'
      ></EditSPEmployeeProfileControlButtons>
    </div>
  </div>
</template>

<script>
import EditSPEmployeeProfileControlButtons
from '@/components/EditSPEmployeeProfile/EditSPEmployeeProfileControlButtons.vue';

export default {
  name: 'EditSPEmployeeProfileHeader',
  components: { EditSPEmployeeProfileControlButtons },
  methods: {
    onEscapeClicked() {
      this.$emit('onCloseEditProfilePopup');
    },
    onDeleteClicked() {
      this.$emit('onDeleteEmployeeClicked');
    },
    onResetActiveClicked() {
      this.$emit('onResetActiveClicked');
    },
    onOpenPreviewClicked() {
      this.$emit('onOpenPreviewClicked');
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.edit-sp-employee-container-header {
  .edit-sp-employee-profile-header-container {
    max-height: rem(56);
    background-color: var(--bg-secondary);
    border-radius: $radius-md $radius-md 0 0;
    box-shadow: 0 0 rem(4) 0 rgba(14, 31, 51, 0.13);
    margin: auto;
    padding-top: rem(14);
    padding-bottom: rem(14);
    display: flex;
  }
}

.edit-sp-employee-profile-header-container-control-buttons {
  padding-right: rem(32);
}

.edit-sp-employee-profile-title {
  width: 33%;
  color: var(--text-tertiary);
  font-family: $font-family-black;
  font-size: rem(20);
  font-weight: 900;
  letter-spacing: 0;
  text-align: left;
  padding-left: rem(32);
  flex: 50%;
}
</style>
